import FormSelect from './FormSelect'
import { mapGetters } from 'vuex'
import {
  getCampuses
} from '@/api'

export default {
  extends: FormSelect,
  props: {
    config: {
      type: Object,
      default: () => ({}),
    },
    formValue: {
      type: Object,
      default: () => ({
        campus: '',
      }),
    },
    campus: {
      type: String,
      default: '',
    },
  },
  data () {
    return {
      isOpen: false,
      isLoading: false,
      options: [],
      optionsLoaded: false,
    }
  },
  computed: {
    ...mapGetters([ 'school' ]),
    mergedConfig () {
      return {
        multiple: false,
        searchable: true,
        options: [],
        ...this.config,
      }
    },
    normalizedOptions () {
      // NOTE: we only want to sort the options loaded in from the BE
      // Any user defined options should retain the sort order in which they were entered
      const options = Object.values(this.options).map(el => el.location).sort()
      const optionsWithHardCodedValues = options.filter(Boolean).concat(this.mergedConfig.options || [])
      // ensuring options are unique and sorting the resulting array
      return [ ...new Set(optionsWithHardCodedValues) ]
    },
    campusWithFallback () {
      return this.campus || this.formValue.campus
    },
  },
  watch: {
    isOpen: {
      async handler (val) {
        if (val && this.campusWithFallback && !this.optionsLoaded) {
          this.isLoading = true
          const { data = {} } = await getCampuses({ school: this.school }) || {}
          const { locations = [] } = Object.values(data).find(campus =>
            campus.campus === this.campusWithFallback || campus.description === this.campusWithFallback) || {}

          this.options = locations || []
          this.optionsLoaded = true
          this.isLoading = false

        }
      },
    },
    campusWithFallback: {
      handler () {
        // when the campus is changed, options must be reloaded
        this.optionsLoaded = false
        this.options = []
      },
    },
  },
  methods: {

  },
}
